export const apiUrl = 'https://dev.api.q-flow.k8s.iradukunda.me';
